import axios from "axios";

// Create axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/json",
  },
});

// Standard API Call Structure as per guidelines
export const apiCall = async (
  endpoint,
  method = "GET",
  data = null,
  customHeaders = {}
) => {
  try {
    const config = {
      url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/email/api/${endpoint}`,
      method: method.toUpperCase(),
      headers: {
        "Content-Type": "application/json",
        jwt_token: localStorage.getItem("login_token"),
        ...customHeaders,
      },
    };

    if (
      data &&
      (method.toUpperCase() === "POST" ||
        method.toUpperCase() === "PUT" ||
        method.toUpperCase() === "PATCH")
    ) {
      config.data = data;
    }

    const response = await axios(config);
    return response;
  } catch (error) {
    throw error;
  }
};

// Success/Error handler utility
export const handleApiResponse = (
  response,
  setLoading,
  setSuccessFailureMessage,
  setOpenSuccessModal,
  setOpenFailureModal,
  navigate = null
) => {
  if (!response.data.error) {
    // Success handling
    setSuccessFailureMessage(response?.data?.message);
    setOpenSuccessModal("dismissible");
  } else {
    // Error handling
    setSuccessFailureMessage(response?.data?.message);
    setOpenFailureModal("dismissible");
  }
  setLoading(false);
};

// Error handler utility
export const handleApiError = (
  error,
  setLoading,
  setSuccessFailureMessage,
  setOpenFailureModal,
  navigate = null
) => {
  console.log(error);
  if (error?.response?.status === 401) {
    localStorage.removeItem("login_token");
    localStorage.removeItem("login_data");
    if (navigate) navigate("/");
  }
  setSuccessFailureMessage(error?.response?.data?.message || error?.message);
  setOpenFailureModal("dismissible");
  setLoading(false);
};

// Complete API call with error handling following the guideline
export const standardApiCall = async (
  endpoint,
  method = "GET",
  data = null,
  setLoading = () => {},
  setSuccessFailureMessage = () => {},
  setOpenSuccessModal = () => {},
  setOpenFailureModal = () => {},
  navigate = null,
  customHeaders = {}
) => {
  setLoading(true);
  try {
    const response = await apiCall(endpoint, method, data, customHeaders);
    handleApiResponse(
      response,
      setLoading,
      setSuccessFailureMessage,
      setOpenSuccessModal,
      setOpenFailureModal,
      navigate
    );
    return response;
  } catch (error) {
    handleApiError(
      error,
      setLoading,
      setSuccessFailureMessage,
      setOpenFailureModal,
      navigate
    );
    throw error;
  }
};

export default axiosInstance;
